import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { Avatar, Collapse, Card, List, Button, Tabs, Layout, Menu, Icon, Row, Col, Table, Divider } from 'antd';
import { QUERY_COLOR, CATEGORY_COLOR } from '../entityColors';
import TabContentHeader from '../TabContentHeader';

const data = [
  'category',
  'another_category',
  'agent_category',
  'testing123',
  'hello_world',
];

const gridStyle = {
  width: '25%',
  textAlign: 'center',
};

const mapStateToProps = state => ({
  connections: Object.values(state.connection.byId),
  currentConnection: R.pathOr({}, ['connection', 'byId', R.path(['connection', '/window', 'ids', '0'], state)], state),
});

const Home = ({ connections, currentConnection }) => (
  <div id="home" style={{ minHeight: '100vh' }}>
    <TabContentHeader
      title="Home"
      icon="home"
    />
    <Row type="flex" style={{ minHeight: '100%' }}>
      <Col span={20} style={{ padding: '32px' }}>
        <h2>Welcome Back.</h2>
        <Divider />
        <div style={{ width: '256px'}}>
          <Card>
            <Card.Meta
              key="connection"
              avatar={
                <Avatar
                  shape="square"
                  icon="api"
                  style={{ background: 'rgb(2, 121, 192)' }}
                >
                  {currentConnection.shortName}
                </Avatar>}
              title={currentConnection.name}
              description="API Connection"
            />
          </Card>
        </div>
      </Col>
    </Row>
  </div>
);

export default connect(mapStateToProps)(Home);
